module.exports = __webpack_public_path__ + "img/yangshuang.21129475.jpg";